import axios from 'axios'
// import MockAdapter from 'axios-mock-adapter'

// const ServicePath = "http://localhost:5002"

// const ServicePath = "http://192.168.0.171:5002"
// const ServicePath = "http://192.168.0.171:3001"
const ServicePath = "https://demoseller.decsoplus.com/db"


export default ServicePath
